module.exports = {"school-name":"Concordia University Wisconsin and Ann Arbor","logo":"/sites/cuw/cuwaa-logo.png","logout-color":"#005596","logout-font-color":"#fff","header-color":"#fff","header-border-color":"#faa634","footer-color":"#000","footer-info":"© 2020 Concordia University Wisconsin & Ann Arbor | The Write Class™ | © 2020 Boise State University","help-button-color":"#faa634","help-button-font-color":"#000000"}


//////////////////
// WEBPACK FOOTER
// ./sites/cuw/site-config.json
// module id = 116
// module chunks = 12